import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@rocketlane/ui';
import styled from 'styled-components';
import { MeshSurface } from './mesh-surface';
const SphereRoot = styled.span`
  position: relative;
  display: inline-flex;
  width: ${({ $size })=>$size}px;
  height: ${({ $size })=>$size}px;
  flex-shrink: 0;
`;
const Overlay = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: #fff;
  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 1))
    drop-shadow(0 0 9px rgba(255, 255, 255, 0.95));
`;
export const MeshSphere = ({ size = 16, iconProps, className, 'data-cy': dataCy, ...rest })=>{
    if (!iconProps) {
        return /*#__PURE__*/ _jsx(MeshSurface, {
            ...rest,
            width: size,
            height: size,
            borderRadius: "50%",
            className: className,
            "data-cy": dataCy
        });
    }
    return /*#__PURE__*/ _jsxs(SphereRoot, {
        $size: size,
        className: className,
        "data-cy": dataCy,
        children: [
            /*#__PURE__*/ _jsx(MeshSurface, {
                ...rest,
                width: size,
                height: size,
                borderRadius: "50%"
            }),
            /*#__PURE__*/ _jsx(Overlay, {
                "aria-hidden": true,
                children: /*#__PURE__*/ _jsx(Icon, {
                    ...iconProps
                })
            })
        ]
    });
};
